<script>
    import ParentFilter from '@/components/page-filter-edit/ParentFilter.vue';

    export default {
        data() {
            return {
                parentFilterValue: null,
            }
        },
        props: {
            storeData: Object,
        },
        computed: {
            data() {return this.storeData},
            filterItem() {return this.$store.getters.FILTER_ITEM(this.data['asset_type_id'])},
        },
        components: {
            ParentFilter: ParentFilter,
        },
        methods: {
            async addParentFilter() {
                if (this.data.parent_ids.includes(this.parentFilterValue)) return;
                this.data.parent_ids.push(this.parentFilterValue);
            },
            async removeParentFilter(id) {
                const parentIndex = this.data.parent_ids.indexOf(id);
                if (parentIndex >= 0) this.data.parent_ids.splice(parentIndex, 1);
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Parent Filter:</label>
        <div 
            class="left_sub_multi_container mt_5 mb_10"
        >
            <select
                class="right_input"
                v-model="parentFilterValue"
            >
                <option :value="null">None</option>
                <option
                    v-for="(filterItemValue, filterItemIndex) in filterItem" :key="filterItemIndex"
                    :value="filterItemValue['id']"
                >
                    {{ filterItemValue['name'] }}
                </option>
            </select>
            <button
                :disabled="parentFilterValue == null"
                class="button_blue_100 ml_10"
                @click="addParentFilter"
            >Add</button>
        </div>
        <div
            v-for="(parentValue, parentIndex) in data['parent_ids']" :key="parentIndex"
            class="left_sub_multi_container mb_10"
        >
            <ParentFilter 
                :filterItemID="parentValue"
                :assetTypeID="data['asset_type_id']"
                :methodDelete="removeParentFilter"
            />
        </div>
    </div>
</template>